// eslint-disable-next-line no-unused-vars, @typescript-eslint/no-unused-vars
export const getWaterfallItemStyles = ({ waterFallItem = {} }, { palette = {} }) => ({
  item: {
    paddingLeft: '8px',
    paddingRight: '8px',
    paddingTop: '8px',
    paddingBottom: '9px',
    fontSize: '12px',
    '&:hover': {
      backgroundColor: palette.neutralLighter,
    },
  },
  text: {
    display: 'inline-block',
    paddingLeft: '8px',
  },
  visibleSelectMark: {
    display: 'inline-block',
    width: '16px',
    height: '16px',
    visibility: 'visible',
  },
  hiddenSelectMark: {
    display: 'inline-block',
    width: '16px',
    height: '16px',
    visibility: 'hidden',
  },
});
